/* cookie-consent.js — makes Shopify's native cookie preferences feel like a second "page" of the
   consent card: injects a Back button and slides between the banner and the preferences panel.
   All consent recording stays 100% Shopify-native (Accept / Decline / Save / the toggles and the
   Manage-preferences "forward" nav are untouched); this only adds navigation + motion + a back arrow. */
(function () {
  if (window.__ccPrefsNav) return; window.__ccPrefsNav = 1;
  var BACK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';

  function injectBack(dialog) {
    if (!dialog) return;
    var header = dialog.querySelector('header');
    if (!header || header.querySelector('.cc-prefs-back')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cc-prefs-back';
    b.setAttribute('aria-label', 'Back to cookie consent');
    b.innerHTML = BACK_SVG;
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); back(dialog); });
    header.appendChild(b);
  }

  function back(dialog) {
    if (dialog.__ccLeaving) return; dialog.__ccLeaving = 1;
    // Slide the prefs page out to the right (cc-leaving -> ccPageOut, fill:both keeps it hidden at the
    // end), then a single showBanner() removes the prefs and renders the banner itself (visible, with
    // its own entrance). No class removal, no close-click -> flicker-free and the banner is never left
    // invisible. The dimmed scrim bridges the brief moment between the two cards.
    dialog.classList.add('cc-leaving');
    var fired = false;
    var finish = function () {
      if (fired) return; fired = true;
      try { if (window.privacyBanner && window.privacyBanner.showBanner) window.privacyBanner.showBanner(); } catch (e) {}
    };
    dialog.addEventListener('animationend', finish, { once: true });
    setTimeout(finish, 300); // fallback if animationend doesn't fire
  }

  // the prefs panel is (re)inserted when "Manage preferences" is clicked -> keep the back button present
  try {
    var mo = new MutationObserver(function () {
      var d = document.querySelector('.shopify-pc__prefs__dialog');
      if (d && !d.querySelector('.cc-prefs-back')) injectBack(d);
    });
    mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  if (document.readyState !== 'loading') {
    var d0 = document.querySelector('.shopify-pc__prefs__dialog'); if (d0) injectBack(d0);
  } else {
    document.addEventListener('DOMContentLoaded', function () { var d = document.querySelector('.shopify-pc__prefs__dialog'); if (d) injectBack(d); });
  }
})();
